import { useCallback } from 'react';
import { ICompanyDetailsWebSocket } from 'global/TableOrderbookWidget/types';
import useDatafeedMessageEffect from '../useDatafeedMessageEffect';
import { UseLivePriceKey, UseLivePriceRes } from './useLivePrice.types';
import { natsLivePriceFormatter } from './useLivePrice.utils';

export type UseLivePriceOnMessage = (
  formattedLivePrice: UseLivePriceRes,
  rawLivePrice: LivePriceResponse | ICompanyDetailsWebSocket,
) => void;

export const useLivePriceReceiver = (
  symbols: string[],
  key: UseLivePriceKey,
  onMessage: UseLivePriceOnMessage,
) => {
  const stringSymbols = symbols.join();

  const handleReceiveMessage = useCallback(
    async (message: DatafeedMessageChannel) => {
      const { liveprice } = message || {};
      if (liveprice && stringSymbols.split(',').includes(liveprice.stockCode)) {
        const formattedLivePrice = natsLivePriceFormatter(liveprice);
        onMessage(formattedLivePrice, liveprice);
      }
    },
    [stringSymbols, onMessage],
  );

  // Nats Socket Receiver
  useDatafeedMessageEffect(
    'liveprice',
    `${key}:${symbols.join()}`,
    handleReceiveMessage,
  );
};
